const getFirstHeaderValue = (value: string | string[] | undefined | null) => {
  if (Array.isArray(value)) return String(value[0] || '').trim();
  return String(value || '').trim();
};

const LOCAL_HOST_PATTERNS = ['localhost', '127.0.0.1', '::1'];
const TEST_HOST_PATTERNS = ['teste.sobressai.com', '143.244.221.227'];

export const normalizeHost = (host: string | string[] | undefined | null) => {
  const firstHost = getFirstHeaderValue(host).split(',')[0].trim();
  if (!firstHost) return '';

  let normalized = firstHost
    .replace(/^https?:\/\//i, '')
    .split('/')[0]
    .split('?')[0]
    .split('#')[0]
    .trim();

  normalized = normalized.replace(/\.+$/, '').replace(/\/+$/, '');
  return normalized;
};

export const isLocalOrTestHost = (host: string | string[] | undefined | null) => {
  const normalized = normalizeHost(host).toLowerCase();
  if (!normalized) return false;

  return (
    LOCAL_HOST_PATTERNS.some((pattern) => normalized.includes(pattern)) ||
    TEST_HOST_PATTERNS.some((pattern) => normalized.includes(pattern))
  );
};

const toPositiveInt = (value: unknown) => {
  const source = Array.isArray(value) ? value[0] : value;
  const parsed = Number(String(source || '').replace(/[^\d]/g, ''));
  if (!Number.isFinite(parsed) || parsed <= 0) return 0;
  return parsed;
};

const resolveHostForQuery = (host?: string | string[] | null) => {
  if (host && normalizeHost(host)) return normalizeHost(host);
  if (typeof window === 'undefined') return '';
  return normalizeHost(window.location.host);
};

export const appendCodsiteQuery = (
  path: string,
  codsite?: unknown,
  host?: string | string[] | null
) => {
  const codsiteNumber = toPositiveInt(codsite);
  if (!codsiteNumber) return path;

  const resolvedHost = resolveHostForQuery(host);
  if (!isLocalOrTestHost(resolvedHost)) return path;

  const [pathWithoutHash, hashFragment = ''] = String(path || '/').split('#');
  const [basePath, queryString = ''] = pathWithoutHash.split('?');
  const searchParams = new URLSearchParams(queryString);
  searchParams.set('codsite', String(codsiteNumber));
  const rebuiltQuery = searchParams.toString();
  const rebuiltPath = rebuiltQuery ? `${basePath}?${rebuiltQuery}` : basePath;
  return hashFragment ? `${rebuiltPath}#${hashFragment}` : rebuiltPath;
};

export const cleanPath = (path: string | undefined | null) => {
  const raw = String(path || '/').trim();
  if (!raw) return '/';

  let normalizedPath = raw;
  if (/^https?:\/\//i.test(raw)) {
    try {
      normalizedPath = new URL(raw).pathname || '/';
    } catch {
      normalizedPath = raw;
    }
  }

  normalizedPath = normalizedPath.split('#')[0].split('?')[0] || '/';
  if (!normalizedPath.startsWith('/')) normalizedPath = `/${normalizedPath}`;
  normalizedPath = normalizedPath.replace(/\/{2,}/g, '/');

  if (normalizedPath.length > 1) {
    normalizedPath = normalizedPath.replace(/\/+$/, '');
  }

  return normalizedPath || '/';
};

export const buildCanonical = (host: string | undefined | null, path: string | undefined | null) => {
  const normalizedHost = normalizeHost(host);
  const normalizedPath = cleanPath(path);

  if (!normalizedHost) return normalizedPath;
  return `https://${normalizedHost}${normalizedPath}`;
};
